import { TextScreen } from '@strata/react-page-templates';

export const TermsAndConditions = () => (
    <TextScreen
        pageTitle="Terms and Conditions"
        content={
            <>
                <p>
                    By submitting a bid in the FMH for Pharmacies application for a specific Live
                    Referral, in addition to meeting the requirements of the Free Market Health
                    Participating Provider Marketplace Agreement (<q>Agreement</q>), Provider
                    confirms that it:
                </p>
                <ul>
                    <li>
                        Has direct access to provide the Specialty Drug Service, as defined in
                        Section 1.1 of the Agreement.
                    </li>
                    <li>
                        Is willing and capable of providing the Specialty Drug Service for at least
                        one (1) year at the confirmed bid rate.
                    </li>
                    <li>
                        Has placed a bid by an Authorized User, as defined in Section 1.1 of the
                        Agreement.
                    </li>
                    <li>
                        Is licensed (and will maintain licensure) in the applicable state(s) for the
                        provision of the Specialty Drug Service to the intended Member.
                    </li>
                    <li>
                        Is capable of meeting and will use best efforts to meet any stated
                        performance metrics, known at the time of the bid, for the Referral.
                    </li>
                    <li>
                        With respect to any applicable performance metrics for such Referral, will
                        use the FMH for Pharmacies application to document or report care processes,
                        care coordination data, or other Member interaction results, as may be
                        required to fulfill the applicable performance metrics.
                    </li>
                </ul>
                <p>
                    In addition, Provider agrees to the final bid rate (subject to price
                    modifications described in Section 1.3 of the Agreement, as may be applicable)
                    as full and final Plan reimbursement for the Specialty Drug Service represented
                    by the Referral, excluding any Member cost share under the terms of the
                    applicable Plan benefit, and any Value Based Service Payments as described in
                    Section 1.6 of the Agreement.
                </p>
                <p>
                    In accordance with Section 1.2(iii) of the Agreement, Provider confirms that
                    these Bid Terms and Conditions become part of and are hereby incorporated into
                    the Agreement without requiring a separate signature.
                </p>
                <p>Capitalized terms are defined in the Agreement.</p>
                <p className="sds_date-stamp">
                    Last Updated: September 14, 2020
                    <br />
                    Reviewed: March 28, 2022
                </p>
            </>
        }
    />
);
